import { Button } from "@/shared/ui/button";
import { TelegramLinks } from "@/shared/types/global/links";
import { useMe } from "@/entities/profile";
import { useSessionStore } from "@/entities/session";
import { Roles } from "@/entities/user";

export const TelegramAssignButton = () => {
  const { user } = useSessionStore();
  const { data, isPending } = useMe();

  if (
    isPending ||
    data?.tgId ||
    user?.role === (Roles.Head || Roles.MasterTeamLead)
  )
    return;

  return (
    <div>
      <span className="text-sm text-orange-500 md:text-[11px]">
        Защитите аккаунт — привяжите Telegram.
      </span>
      <Button variant="outline" asChild>
        <a
          className="w-full"
          target="_blank"
          href={`${TelegramLinks.TELEGRAM_ACCOUNT_ASSIGN}`}
        >
          Привязать
        </a>
      </Button>
    </div>
  );
};
